export default function (errMessage) {
  return (errMessage || errMessage === '') ? new Error(errMessage) : null
}